import { log } from '@/log'
import { ApiProductclass } from '@/models/api/productclass'
import { compact, flatten, head, last, uniq } from 'lodash'

export interface LensDetail {
  power: string | null
}

const emptyLensDetail: LensDetail = {
  power: null,
}

/**
 * @deprecated
 * PHP側に実装を集約したいので利用は原則禁止
 *
 * PHP側に同様の実装あり
 * @see App\Response\Item\ContactLens\ItemList\ContactLensFKUViewModel::powers
 */
export function createLensDetail(fku: ApiProductclass): LensDetail {
  const powerPathName = 'company.product.size'
  const allTags = flatten(fku.materializedSkuList.map(sku => sku.tags))
  const lensPowerTags = allTags.filter(tag => (
    tag.pathname.indexOf(powerPathName) === 0 &&
    tag.getDisplayLevelOrElse(null) !== null
  ))

  const lensPowerList = LensPowerList.valueOf(compact(lensPowerTags.map(tag => (
    LensPower.parse(tag.label, tag.displayLevel)
  ))))

  try {
    if (lensPowerList.isEmpty) {
      return emptyLensDetail
    }

    return {
      power: lensPowerList.toRange().toString(),
    }
  } catch (error) {
    log.error(error)

    return emptyLensDetail
  }
}

/**
 * @deprecated
 * PHP側に実装を集約したいので利用は原則禁止
 *
 * PHP側に同様の実装あり
 * @see App\Response\Item\ContactLens\ItemList\Power\LensPower
 */
class LensPower {
  static parse(str: string, priority: number): LensPower | null {
    const found = str.match(/([+\-±]\d+\.\d+)/u)

    return found ? new LensPower(found[0], priority) : null
  }

  private constructor(
    private readonly label: string,
    private readonly priority: number
  ) {}

  compare(other: LensPower): number {
    if (this.priority > other.priority) {
      return 1
    }
    if (this.priority === other.priority) {
      return 0
    }

    return -1
  }

  toString(): string {
    return this.label
  }
}

/**
 * @deprecated
 * PHP側に実装を集約したいので利用は原則禁止
 *
 * PHP側に同様の実装あり
 * @see App\Response\Item\ContactLens\ItemList\Power\LensPowerList
 */
class LensPowerList {
  static valueOf(list: LensPower[]): LensPowerList {
    return new LensPowerList(list)
  }
  static empty(): LensPowerList {
    return new LensPowerList([])
  }

  private constructor(
    private readonly list: LensPower[]
  ) {}

  get isEmpty(): boolean {
    return this.list.length === 0
  }

  toRange(): LensPowerRange {
    const sorted = this.list.sort((a, b) => a.compare(b))
    const lowest = head(sorted)
    const highest = last(sorted)

    if (lowest === undefined || highest === undefined) {
      throw new Error(`can not convert empty lens power list to lens power range`)
    }

    return new LensPowerRange(lowest, highest)
  }
}

/**
 * @deprecated
 * PHP側に実装を集約したいので利用は原則禁止
 *
 * PHP側に同様の実装あり
 * @see App\Response\Item\ContactLens\ItemList\Power\LensPowerRange
 */
class LensPowerRange {
  constructor(
    private readonly begin: LensPower,
    private readonly end: LensPower
  ) {}

  beginEnd(): LensPower[] {
    return [this.begin, this.end]
  }

  toString(): string {
    return uniq(this.beginEnd().map(p => p.toString())).join('〜')
  }
}
